// eslint-disable-next-line no-unused-vars
import React, { memo, useEffect, useState } from 'react';

import useFetch from 'Hooks/useFetch';
import useUser from 'Hooks/useUser';
import useNumberUtils from 'Hooks/useNumberUtils';
import useAsyncError from 'Hooks/useAsyncError';
import useAnalytics from 'Hooks/useAnalytics';
import download from 'Utils/download';
import FeedsComponent from 'Components/APIIntegrations/Feeds';
import { API_FEEDS } from 'Constants';

const Feeds = memo(() => {
  const [feeds, setFeeds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingFeed, setLoadingFeed] = useState('');
  const fetcher = useFetch();
  const { formatDate } = useNumberUtils();
  const throwError = useAsyncError();
  const { data: { email, loggedIn } = {} } = useUser();
  const analytics = useAnalytics();

  const getFeeds = () => {
    setLoading(true);

    fetcher(API_FEEDS).then(res => {
      setFeeds(res?.map(item => ({
        ...item, updatedAt: formatDate((item?.updated || item?.added), { timeStyle: undefined })
      })));
    }).catch(err => throwError(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (loggedIn) {
      getFeeds();
    }
  }, [email, loggedIn]);

  const handleFeedDownload = async ({ format, onlyResealed = false, isSupplier = false }) => {
    try {
      let feedType = 'nod';

      if (onlyResealed) {
        feedType = 'resealed';
      } else if (isSupplier) {
        feedType = 'supplier';
      }

      analytics.track('feed_download_clicked', {
        feed_type: feedType,
        file_format: format,
      });
      setLoadingFeed(`${format}-${onlyResealed ? 'resealed' : 'all'}${isSupplier ? '-supplier' : ''}`);

      const baseUrl = isSupplier ? '/api/supplier-products/offers/feed' : '/products/full-feed';

      const params = new URLSearchParams();
      params.append('format', format);

      if (onlyResealed) {
        params.append('only_resealed', '1');
      }

      const downloadUrl = `${baseUrl}?${params.toString()}`;
      await download(downloadUrl);
    } catch (err) {
      throwError(err);
    } finally {
      setLoadingFeed('');
    }
  };

  const handleDownload = url => {
    analytics.track('download_clicked');
    download(url);
  };

  return (
    <FeedsComponent
      feeds={ feeds }
      loading={ loading }
      handleDownload={ handleDownload }
      handleFeedDownload={ handleFeedDownload }
      loadingFeed={ loadingFeed }
    />
  );
});

Feeds.propTypes = {
};

Feeds.displayName = 'FeedsContainer';

export default Feeds;
